import {
  EvaluationCriteria,
  EvaluationCriteriaTranslation,
  EvaluationSubCriteriaDirectus,
  EvaluationSubCriteriaTranslation,
  SubcriteriaAttributeDirectus,
} from '@frontend/directus';
import {EvaluationCriteriaResponse} from '@frontend/shared-api';
import {TabStatusEnum} from '../../../../../../shared/tabs/tab-status.model';
import {AttributeScoreVM} from '../../../../../../shared/components/sub-criteria-tab/sub-criteria-tab.types';
import {ModuleTab} from './ec3-module-group/ec3-module-group.types';

export interface SubCriteriaTabVM {
  id: number;
  directusId: string;
  scNumber: number;
  translations: EvaluationSubCriteriaTranslation[];
  attributes: AttributeScoreVM[];
  status: TabStatusEnum;
  unresolvedConsistencyCount: number;
  clarificationConsistencyCount: number;
}

export interface EvaluationCriteriaTabVM {
  id: number;
  ecNumber: number;
  translations: EvaluationCriteriaTranslation[];
  subCriteria: SubCriteriaTabVM[];
  status: TabStatusEnum;
  unresolvedConsistencyCount: number;
  clarificationConsistencyCount: number;
}

export interface CriteriaCatalog {
  criteria: EvaluationCriteria[];
  subCriteria: EvaluationSubCriteriaDirectus[];
  attributes: SubcriteriaAttributeDirectus[];
}

export interface ProjectScores {
  criteria: EvaluationCriteriaResponse[];
  attributeIdsBySubCriteria: Map<number, string[]>;
}

export const EMPTY_PROJECT_SCORES: ProjectScores = {
  criteria: [],
  attributeIdsBySubCriteria: new Map(),
};

export const EMPTY_CRITERIA_CATALOG: CriteriaCatalog = {
  criteria: [],
  subCriteria: [],
  attributes: [],
};

export const EMPTY_MODULE_TABS: ModuleTab[] = [];
